import React, { useState, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import TextBlock from '../form/blocks/TextBlock';
import CommonModal from '../common/CommonModal';
import axios from 'axios';
import { config } from '../../utils/config';


export default function Register() {

    const navigate = useNavigate();

    const [username, setUsername] = useState("");
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [successModal, setSuccessModal] = useState(false)
    const [errorModal, setErrorModal] = useState(false)
    const [errorEmptyModal, setErrorEmptyModal] = useState(false)
    const [usernameError, setUsernameError] = useState("")
    const [emailError, setEmailError] = useState("")
    const [passwordError, setPasswordError] = useState("")
    const [confirmPasswordError, setConfirmPasswordError] = useState("")

    // form validation
    const checkUsername = useCallback(() => {
        if (username.length < 4) {
            setUsernameError("username must have at least 4 characters");
        } else { setUsernameError("") }
    }, [username.length])

    const checkEmail = useCallback(() => {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!regex.test(email)) {
            setEmailError("Invalid email format")
        } else { setEmailError("") }
    }, [email])

    const checkPassword = useCallback(() => {
        if (password.length < 4) {
            setPasswordError("password must have at least 4 characters")
        } else { setPasswordError("") }
        if (password !== confirmPassword) {
            setConfirmPasswordError("password does not match")
        } else { setConfirmPasswordError("") }
    }, [password, confirmPassword])

    const checkConfirmPassword = useCallback(() => {
        if (confirmPassword !== password) {
            setConfirmPasswordError("password does not match")
        } else { setConfirmPasswordError("") }
    }, [confirmPassword, password])


    const googleLogin = () => {
        window.open(`${config.apiBaseUrl}/google-login/auth/google`, '_self');
    }

    const registerUser = useCallback(async (event) => {
        event.preventDefault();

        if (username && email && password && confirmPassword && !usernameError && !emailError && !passwordError && !confirmPasswordError) {

            try {
                const response = await axios.post(`${config.apiBaseUrl}/user/registration`, {
                    username,
                    password,
                    email
                }, { withCredentials: true });

                console.log("response", response.data)
                if(response.data === "registration successful"){
                    setSuccessModal(true)
                    // console.log("form submitted")
                }
                if(response.data === "user found"){
                    setErrorModal(true)
                }
                
            } catch (error) {
                console.log(error)
                setErrorEmptyModal(true)
            }
           
        } else {

            setErrorEmptyModal(true)
            console.log("not submitted")
        
        }
    }, [password, username, email, confirmPassword, confirmPasswordError, emailError, passwordError, usernameError])


    return (
        <>
            <div className="d-flex justify-content-center">
                <div className="container m-3">

                    <h5 className="text-center">Register</h5>

                    <span onKeyUp={checkUsername}>
                        <TextBlock label={"Username"} updateParentValue={(value) => { setUsername(value) }} style={{ margin: "0", lineHeight: "1" }} errorMessage={usernameError} />
                    </span>
                    <span onKeyUp={checkEmail}>
                        <TextBlock type="email" label={"Email"} updateParentValue={(value) => { setEmail(value) }} errorMessage={emailError} />
                    </span>
                    <span onKeyUp={checkPassword}>
                        <TextBlock type="password" label={"Password"} updateParentValue={(value) => { setPassword(value) }} errorMessage={passwordError} />
                    </span>
                    <span onKeyUp={checkConfirmPassword}>
                        <TextBlock type="password" label={"Confirm Password"} updateParentValue={(value) => { setConfirmPassword(value) }} errorMessage={confirmPasswordError} />
                    </span>

                    <div>
                        <button className="btn btn-danger me-3" onClick={registerUser} >register</button>
                    </div>

                    <div className="my-3">
                        <button className="btn btn-danger" onClick={googleLogin}>Sign up with Google Login</button>
                    </div>

                </div>
            </div>
            <CommonModal title="Registration Successful" message="Please Proceed to Login" show={successModal} handleClose={() => { setSuccessModal(false); navigate("/login") }} />
            <CommonModal title="Already Registered" message="You Are Already Registered. Please Proceed to Login" show={errorModal} handleClose={() => { setErrorModal(false); navigate("/login") }} />
            <CommonModal title="Empty Field" message="Please fill ensure that no field is empty" show={errorEmptyModal} handleClose={() => { setErrorEmptyModal(false) }} />
        </>
    );
}

